/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum Language {
    DE = 'DE',
    EN = 'EN',
    FR = 'FR',
}
